export function scrollToTranscript(questionId: string): void {
  const el = document.getElementById(`transcript-q-${questionId}`);
  if (!el) return;
  el.scrollIntoView({ behavior: 'smooth' });
  el.classList.add('transcript-highlight');
  setTimeout(() => {
    el.classList.remove('transcript-highlight');
  }, 2000);
}

export function verdictColor(verdict: string | null): string {
  switch (verdict) {
    case 'pass':
      return 'text-green-600';
    case 'fail':
      return 'text-red-600';
    default:
      return 'text-yellow-600';
  }
}

export function getScoreColor(score: number): string {
  if (score >= 4) return 'text-green-600';
  if (score >= 3) return 'text-yellow-600';
  return 'text-red-600';
}
